import _ from "lodash";

//import * as axios from 'axios';
// function upload(formData) {
//     const url = `${BASE_URL}/photos/upload`;
//     return axios.post(url, formData)
//         // get data
//         .then(x => x.data)
//         // add url field
//         .then(x => x.map(img => Object.assign({},
//             img, { url: `${BASE_URL}/images/${img.id}` })));
// }

function uploadFake(formData) {    
    const photos = formData.getAll('photos');        
    const promises = photos.map((x) => getImage(x)
        .then(img => ({            
            id: 0,
            name: x.name,
            size: parseFloat((x.size / 1024 / 1024).toFixed(2)),
            extension: _.last(x.name.split('.')),
            fullUrl: img,
            url: img,
            actived: true
        })));
    return Promise.all(promises);
}

function getImage(file) {
    return new Promise((resolve) => {
        const fReader = new FileReader();
        const img = document.createElement('img');

        fReader.onload = () => {
            img.src = fReader.result;
            resolve(getBase64Image(img));
        }

        fReader.readAsDataURL(file);
    })
}

function getBase64Image(img) {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;

    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    const dataURL = img.src;
    return dataURL;
}

export { uploadFake }